import {HandleErrorType} from "../../components/utils/ErrorBoundary";
import {INTERNAL_ERROR_TYPE} from "../../components/lib/payments/PaymentController";
import {FUNDING_SOURCE} from "@paypal/paypal-js";

export type ErrorPlaceInfoType = Error & {place: string; paymentSource: FUNDING_SOURCE};

export const onErrorClosure = (handleError: HandleErrorType, occurence: string) => {
  let lastErrorTime = 0;

  return (error: Error | Record<string, unknown>) => {
    // Distinguish between our onError call and internal catch callback of 'throw'
    const dateNow = Date.now();
    if (lastErrorTime + 200 > dateNow) {
      lastErrorTime = dateNow;

      // Ignore potentially double thrown error
      return;
    }
    lastErrorTime = dateNow;

    // is it an `Error`, or an error object
    const isErrorInstance = error instanceof Error;

    // If thrown by callbacks, set appropiate error name
    if ((error as ErrorPlaceInfoType).place) {
      (error as Error).name =
        (error as ErrorPlaceInfoType).place + (isErrorInstance ? "" : "Object") + (error as Error).name;
    } else {
      (error as Error).name =
        INTERNAL_ERROR_TYPE.PAYPAL.PayPalRelated + (isErrorInstance ? "" : "Object") + (error as Error).name;
    }

    if (isErrorInstance) {
      handleError(error, `${occurence} error`);
    } else {
      const objectError = new Error(occurence + " error object (not an `Error` instance)");
      objectError.name = (error as {name: string}).name;
      (objectError as Error & {origin: Error | Record<string, unknown>}).origin = error;

      handleError(objectError, `${occurence} non-Error object`);
    }
  };
};
